module.exports = __webpack_public_path__ + "img/InviteFriends-backgroundImg.a050fdc9.png";